
import useScrollAnimation from '../../../hooks/useScrollAnimation';

export default function ValuePillars() {
  const ref = useScrollAnimation();

  const pillars = [
    {
      icon: 'ri-eye-line',
      title: 'Perspective First',
      description: 'We analyze your full operational landscape before building anything.',
      image: 'https://public.readdy.ai/ai/img_res/44cfd79767c6590757e4f12eb3cf3332.jpg',
    },
    {
      icon: 'ri-settings-3-line',
      title: 'Calm Automation',
      description: 'AI systems that integrate quietly and reduce operational friction.',
      image: 'https://readdy.ai/api/search-image?query=Elegant%20minimal%20abstract%20representation%20of%20smooth%20flowing%20mechanical%20gears%20and%20circuits%20in%20soft%20blue%20and%20white%20tones%20on%20clean%20background%20representing%20seamless%20automation%20and%20technology%20integration%20calm%20premium%20aesthetic&width=600&height=400&seq=vp002&orientation=landscape',
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Steady Improvement',
      description: 'Measured, sustainable optimization — not chaotic change.',
      image: 'https://readdy.ai/api/search-image?query=Clean%20minimal%20abstract%20upward%20trending%20graph%20visualization%20with%20soft%20blue%20gradient%20lines%20on%20white%20background%20representing%20steady%20growth%20and%20continuous%20improvement%20in%20business%20performance%20calm%20refined%20aesthetic&width=600&height=400&seq=vp003&orientation=landscape',
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Intelligent Execution',
      description: 'Strategy-driven implementation aligned to business outcomes.',
      image: 'https://readdy.ai/api/search-image?query=Abstract%20minimal%20neural%20network%20visualization%20with%20interconnected%20glowing%20nodes%20in%20soft%20blue%20and%20white%20tones%20on%20clean%20background%20representing%20intelligent%20strategy%20and%20smart%20execution%20premium%20tech%20aesthetic&width=600&height=400&seq=vp004&orientation=landscape',
    },
  ];

  return (
    <section ref={ref} className="py-28 bg-white">
      <div className="max-w-7xl mx-auto px-8 lg:px-12">
        <div className="text-center mb-20">
          <p className="animate-on-scroll text-[13px] font-medium text-anchor tracking-wide uppercase mb-4">Our Approach</p>
          <h2 className="animate-on-scroll text-4xl md:text-5xl font-light text-navy mb-5 tracking-tight" style={{ transitionDelay: '0.1s' }}>
            Clarity Before Complexity
          </h2>
          <p className="animate-on-scroll text-base text-navy/50 font-light max-w-lg mx-auto" style={{ transitionDelay: '0.15s' }}>
            We simplify operations through intelligent, steady system design.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {pillars.map((pillar, index) => (
            <div
              key={index}
              className="animate-on-scroll group relative bg-drift rounded-2xl overflow-hidden hover:shadow-xl hover:shadow-navy/5 transition-all duration-500 cursor-pointer"
              style={{ transitionDelay: `${0.1 * index}s` }}
            >
              <div className="flex flex-col sm:flex-row">
                <div className="sm:w-1/2 p-8 sm:p-10 flex flex-col justify-center">
                  <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-white mb-5">
                    <i className={`${pillar.icon} text-xl text-anchor`}></i>
                  </div>
                  <h3 className="text-xl font-medium text-navy mb-3 tracking-tight">
                    {pillar.title}
                  </h3>
                  <p className="text-sm text-navy/50 leading-relaxed font-light">
                    {pillar.description}
                  </p>
                </div>
                <div className="sm:w-1/2 h-48 sm:h-auto">
                  <img
                    src={pillar.image}
                    alt={`${pillar.title} - SkySails AI`}
                    title={`${pillar.title} - intelligent systems`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
